module.exports = __webpack_public_path__ + "static/img/prizes.0500baf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/prizes.png
// module id = YJOm
// module chunks = 1